import Vue from 'vue'
import MaterialIcon from '@/components/parts/MaterialIcon.vue'
import BaseContentWrapper from '@/components/parts/BaseContentWrapper.vue'
import BaseListItem from '@/components/parts/BaseListItem.vue'
import BasePageContainer from '@/components/parts/BasePageContainer.vue'

Vue.component('MaterialIcon', MaterialIcon)
Vue.component('BaseContentWrapper', BaseContentWrapper)
Vue.component('BaseListItem', BaseListItem)
Vue.component('BasePageContainer', BasePageContainer)